import React from 'react';

/**
 * useDebounce - used to delay fetch api call like search params etc...
 * @param value - value delayed
 * @param delay - delay in ms default 1000ms
 */
const useDebounce = (value: string, delay = 1000) => {
	const [debounceValue, setDebounceValue] = React.useState<string>(value);

	React.useEffect(() => {
		const timer = setTimeout(() => setDebounceValue(value), delay);
		return () => {
			clearTimeout(timer);
		};
	}, [delay, value]);

	return debounceValue;
};

export default useDebounce;
